import { SESSION_TYPE } from "constants/routes";
import { serviceRoles } from "config/access";
import { checkAccess } from "helpers/auth";
import SessionTypePage from "./container/SessionTypePage";

export default function getSettingsRoute(userAuth) {
  const { account } = serviceRoles;
  const requireAuth = {
    [account.name]: [account.roles.superadmin],
  };
  return {
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    path: SESSION_TYPE,
    withSidebar: true,
    withAppBar: true,
    component: SessionTypePage,
  };
}
